/**
 * Translations for ParkPage (v0.14.0).
 * Park bundles the standalone /zoo + /shop + /games + multi-pet selector.
 * Includes the soft "rest your eyes" modal copy that fires when the
 * daily play window is exhausted inside /park.
 */
const park = {
  zh: {
    'park.title': '我的乐园',
    'park.tab.scene': '🏠 主场景',
    'park.tab.zoo': '🦁 动物园',
    'park.tab.shop': '🛍️ 宠物店',
    'park.tab.games': '🎮 迷你游戏',
    'park.tab.pets': '🐾 我的宠物',
    'park.pets.title': '我的宠物',
    'park.pets.subtitle': '共 {count} 位动物伙伴，挑一只一起出门玩吧',
    // Soft sleep nudge — only fires inside /park; the kid can still go
    // home, do schedule, or chat freely.
    'park.softSleep.title': '该歇歇眼睛了 ✨',
    'park.softSleep.body': '今天在乐园玩了 {minutes} 分钟（上限 {limit}）。回家陪宠物聊聊天，或者去做做日程吧～',
    'park.softSleep.gotoHome': '🏠 回家陪宠物',
    'park.softSleep.gotoSchedule': '📅 看看日程',
    'park.softSleep.dismiss': '好的，我知道了',
  },
  en: {
    'park.title': 'My Park',
    'park.tab.scene': '🏠 Home',
    'park.tab.zoo': '🦁 Zoo',
    'park.tab.shop': '🛍️ Shop',
    'park.tab.games': '🎮 Mini Games',
    'park.tab.pets': '🐾 My Pets',
    'park.pets.title': 'My Pets',
    'park.pets.subtitle': '{count} animal friends — pick one to head out with',
    'park.softSleep.title': 'Time to rest your eyes ✨',
    'park.softSleep.body': "You've played {minutes} min in the park today (limit {limit}). Head home to chat with your pet, or check your schedule.",
    'park.softSleep.gotoHome': '🏠 Head home',
    'park.softSleep.gotoSchedule': '📅 See schedule',
    'park.softSleep.dismiss': 'Got it',
  },
};

export default park;
